import { render, staticRenderFns } from "./EditTotalQueries.vue?vue&type=template&id=fa264918&"
import script from "./EditTotalQueries.vue?vue&type=script&lang=js&"
export * from "./EditTotalQueries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports